export enum CartTicketStatus {
    Open = 2,
    Pending = 3,
    Resolved = 4,
    Closed = 5,
    WaitingOnCustomer = 6,
    WaitingOnFaytech = 7,
    WaitingOnTransport = 8,
    RepairScheduled = 9,
    RepairInProgress = 10,
    ReturnScheduled = 11,
    WaitingOnEdeka = 12,
    Reminder = 13,
    Dispatched = 14,
    Delivered = 15,
    Returned = 16,
    PickupScheduled = 17,
    Deployed = 18,
    Processing = 19,
}

export function getCartTicketStatus(status: number): string | undefined {
    const found = Object.entries(CartTicketStatus).find(([, v]) => v === status);
    if (found) {
        return found[0];
    }
    return;
}
